var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1238_3748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15646 5.98621C2.618 5.98621 0.310303 6.73667 0.310303 7.34221V17.5247C0.310303 18.1164 2.618 18.9093 8.15646 18.9093C13.6949 18.9093 16.0026 18.1588 16.0026 17.5533V7.37082C16.0026 6.77913 13.6949 5.98621 8.15646 5.98621ZM23.7334 6.01482C23.5782 6.02101 23.4281 6.07128 23.3005 6.15974L17.3005 10.0247C17.0697 10.1982 16.9257 10.4844 16.9257 10.7751V14.1204C16.9257 14.4111 17.0697 14.6964 17.3005 14.8708L23.3005 18.7367C23.4629 18.8594 24.2531 19.2444 24.2531 17.9862V6.90928C24.2531 6.18282 24.0029 6.00374 23.7334 6.01482Z",
    fill: "#4CAF50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1238_3748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24.3103 0.447754)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.9b22c6dc0a2e1db596cc360f9f9130fa.svg";
export { ForwardRef as ReactComponent };